import { useEffect, useState } from "react";
import { FiSearch, FiCalendar, FiX } from "react-icons/fi";


const Filtros = ({ onBuscar, loading, resultados }) => {


	const [fechaDesde, setFechaDesde] = useState("");
	const [fechaHasta, setFechaHasta] = useState("");
	const [filtros, setFiltros] = useState("");
	const [idResultadoGestion, setIdResultadoGestion] = useState("");

	const handleLimpiar = () => {
		setFechaDesde("");
		setFechaHasta("");
		setFiltros("");
		setIdResultadoGestion("");
		onBuscar("", "", "");
	};

	const handleBuscar = () => {
		onBuscar(fechaDesde, fechaHasta, filtros, idResultadoGestion);
	};

	const tieneFiltro = fechaDesde || fechaHasta || filtros || idResultadoGestion;


	return (
		<div
			className="max-w-[1400px] mx-auto mb-6 rounded-2xl border border-white/10 px-6 py-4"
			style={{ background: "linear-gradient(145deg, #161a4a, #1e2460)" }}
		>
			<div className="flex flex-wrap items-end gap-4">
				{/* Fecha Desde */}
				<div className="flex flex-col gap-1.5 min-w-[180px]">
					<label className="text-xs font-bold uppercase tracking-widest text-indigo-400 flex items-center gap-1.5">
						<FiCalendar className="text-indigo-400" />
						Fecha Desde
					</label>
					<div className="relative">
						<input
							type="date"
							value={fechaDesde}
							onChange={(e) => setFechaDesde(e.target.value)}
							max={fechaHasta || undefined}
							className="w-full rounded-xl px-4 py-2.5 text-sm text-white border border-white/20 focus:border-indigo-400 outline-none transition-colors pr-8"
							style={{
								background: "rgba(255,255,255,0.06)",
								colorScheme: "dark",
							}}
						/>
					</div>
				</div>

				{/* Fecha Hasta */}
				<div className="flex flex-col gap-1.5 min-w-[180px]">
					<label className="text-xs font-bold uppercase tracking-widest text-indigo-400 flex items-center gap-1.5">
						<FiCalendar className="text-indigo-400" />
						Fecha Hasta
					</label>
					<div className="relative">
						<input
							type="date"
							value={fechaHasta}
							onChange={(e) => setFechaHasta(e.target.value)}
							min={fechaDesde || undefined}
							className="w-full rounded-xl px-4 py-2.5 text-sm text-white border border-white/20 focus:border-indigo-400 outline-none transition-colors"
							style={{
								background: "rgba(255,255,255,0.06)",
								colorScheme: "dark",
							}}
						/>
					</div>
				</div>

				{/* Buscar */}
				<div className="flex flex-col gap-1.5 min-w-[180px]">
					<label className="text-xs font-bold uppercase tracking-widest text-indigo-400 flex items-center gap-1.5">
						{/* <FiCalendar className="text-indigo-400" /> */}
						Buscar
					</label>
					<div className="relative">
						<input
							type="text"
							value={filtros}
							onChange={(e) => setFiltros(e.target.value)}
							className="w-full rounded-xl px-4 py-2.5 text-sm text-white border border-white/20 focus:border-indigo-400 outline-none transition-colors"
							style={{
								background: "rgba(255,255,255,0.06)",
								colorScheme: "dark",
							}}
						/>
					</div>
				</div>

				{/* Estados */}
				<div className="flex flex-col gap-1.5 min-w-[200px]">
					<label className="text-xs font-bold uppercase tracking-widest text-indigo-400 flex items-center gap-1.5">
						Estado
					</label>

					<div className="relative">
						<select
							value={idResultadoGestion}
							onChange={(e) => setIdResultadoGestion(e.target.value)}
							className="w-full rounded-xl px-4 py-2.5 text-sm text-white border border-white/20 focus:border-indigo-400 outline-none transition-colors"
							style={{
								background: "rgba(255,255,255,0.06)",
								colorScheme: "dark",
							}}
						>
							<option className="text-black" value="">Todos</option>
							<option className="text-black" value="null">Sin gestión</option>

							{resultados
								?.filter(r => r.Activo)
								.map((r) => (
									<option
										className="text-black"
										key={r.idResultadoGestion}
										value={r.idResultadoGestion}
									>
										{r.Descripcion}
									</option>
								))
							}

						</select>
					</div>
				</div>

				{/* Divider vertical */}
				<div className="hidden md:block w-px h-10 bg-white/10 self-end mb-0.5" />

				{/* Botones */}
				<div className="flex items-end gap-3 flex-1 justify-end">
					{/* Limpiar — solo visible si hay filtro activo */}
					{tieneFiltro && (
						<button
							onClick={handleLimpiar}
							disabled={loading}
							className="flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-semibold text-indigo-300 border border-white/20 hover:bg-white/10 transition-all disabled:opacity-50"
						>
							Limpiar
						</button>
					)}

					{/* Consultar */}
					<button
						onClick={handleBuscar}
						disabled={loading}
						className="flex items-center gap-2 px-6 py-2.5 rounded-xl text-sm font-bold text-white transition-all disabled:opacity-60 hover:brightness-110 hover:scale-105 active:scale-95"
						style={{
							background: "linear-gradient(135deg, #4f5ef7, #2D3689)",
							boxShadow: "0 4px 20px rgba(79,94,247,0.35)",
						}}
					>
						{loading ? (
							<>
								<div className="w-4 h-4 rounded-full border-2 border-white border-t-transparent animate-spin" />
								Consultando…
							</>
						) : (
							<>
								<FiSearch />
								Consultar
							</>
						)}
					</button>
				</div>
			</div>

		</div>
	)
}

export default Filtros